export default "__VITE_ASSET__COZffP4H__"